import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Rates.title',
    defaultMessage: 'Let’s set your rates',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Rates.subtitle',
    defaultMessage: 'The speed at which we can send a price to the customer is crucial to the amount of jobs. Therefore, we need your rates on these standard products so we always have them ready to ship to the customer. \n\nWe ask you to review our suggested rates first - you can either accept them and become a Voice Star or you can enter your own prices.\n',
  },
  internalSupplierSubtitle: {
    id: 'containers.SupplierProfile.components.Rates.internalSupplierSubtitle',
    defaultMessage: 'The speed at which we can send a price to the customer is crucial to the amount of jobs. Therefore, we need your rates on these standard products so we always have them ready to ship to the customer.\n',
  },
  explanationExpandLabel: {
    id: 'containers.SupplierProfile.components.Rates.explanation.expand',
    defaultMessage: 'Why do you have suggested rates and what do they mean for me?',
  },
  explanationCollapseLabel: {
    id: 'containers.SupplierProfile.components.Rates.explanation.collapse',
    defaultMessage: 'Hide description of why do we have suggested rates',
  },
  explanationContent: {
    id: 'containers.SupplierProfile.components.Rates.explanation.content',
    defaultMessage: 'Our customers’ needs – especial regarding digital media -  are always changing. That is why we would like to encourage you to meet our customers’ wishes and review our rates for the selected products.\nOur rates are adjusted to match the long-term marked, and an attempt to find a solution to current industry demands that benefits everyone involved.\n\nBy accepting these rates, you’ll be a Voice Star on our website and database.\n\nWhat does it mean to be a Voice Star?\nVoice Stars appear on our website as such, meaning they’re easier for visitors and customers to spot and recognize. Our sales team will also prioritize your profile when screening for casting selections to clients.\n\nWhat happens if I DON\'T accept the proposed rates? \nIf you don’t accept our proposed rates, you’ll be able to enter your own customized rates. We have a deep respect and admiration for the voice talents in our roster, and we understand you might already work with established rates you’re not willing to renegotiate.\n\nCustomized rates are not compatible with being a Voice Star. However, as a non Voice Star, you will still feature on VoiceArchive’s website, and clients will always be able to find and book you.\nOur sales team will still present you to the selected castings fitting your rates and language offering.',
  },
  standardLabel: {
    id: 'containers.SupplierProfile.components.Rates.suggested.label',
    defaultMessage: 'Suggested rates',
  },
  standardLabelHint: {
    id: 'containers.SupplierProfile.components.Rates.suggested.label.hint',
    defaultMessage: 'Better exposure, perks, and benefits',
  },
  customisedLabel: {
    id: 'containers.SupplierProfile.components.Rates.customised.label',
    defaultMessage: 'Customized rates',
  },
  customisedLabelHint: {
    id: 'containers.SupplierProfile.components.Rates.customised.label.hint',
    defaultMessage: 'Not eligible for featured benefits',
  },
  customisedLabelWarning: {
    id: 'containers.SupplierProfile.components.Rates.customised.label.warning',
    defaultMessage: 'We’d like you to review our rates before activating this tab. Once you’ve done this, you’ll be able to opt-in or out. Opting out will activate the customized rates.',
  },
  customisedWarning: {
    id: 'containers.SupplierProfile.components.Rates.customised.warning',
    defaultMessage: 'When opting out of our standard rates, you\'re saying \'no, thank you\' to better recognition on our website and to our sales team prioritising your profile when screening for casting selections to clients.',
  },
  productHint0: {
    id: 'containers.SupplierProfile.components.Rates.productHint.0',
    defaultMessage: 'Extra',
  },
  productHint1: {
    id: 'containers.SupplierProfile.components.Rates.productHint.1',
    defaultMessage: 'Recording of a book, usually distributed via online streaming and download. Recordings can vary from under 1 hour to up to 5+ hours finished recording. \n\nAudiobook recordings require experience reading long texts and keeping the listener interested in the book (stamina). Acting skills may be necessary for character roles.',
  },
  productHint2: {
    id: 'containers.SupplierProfile.components.Rates.productHint.2',
    defaultMessage: 'Usually used in museums and on tour buses. Varying from only a few minutes to a series of \'chapters\'. \n \nSmall announcements can also be used in-store, i.e. informing of a shop\'s closing hours. ',
  },
  productHint3: {
    id: 'containers.SupplierProfile.components.Rates.productHint.3',
    defaultMessage: 'E-learning voice-overs can be everything from short 1-minute ‘nuggets’ to long, complex training modules. Common for all e-learning voice-overs is that the aim is to convey knowledge to the listener. \n \nBatch deliveries may be requested. \nPossible character recording is also included in this product. \n \nBundling of modules is possible (if the end client is the same). \nCalculations are based on total word count per recording order. ',
  },
  productHint4: {
    id: 'containers.SupplierProfile.components.Rates.productHint.4',
    defaultMessage: 'Navigation',
  },
  productHint5: {
    id: 'containers.SupplierProfile.components.Rates.productHint.5',
    defaultMessage: 'A broad category encompassing all voice-overs applied to video production. \n \nExamples: \n•        Product videos explaining and highlighting product features \n•        Image videos aiming to boost a company’s (or product’s) image positively \n•        Explainers or tutorial videos, explaining and presenting “how-to” use a software, feature or process guides \n \nBundling of modules is possible (if the end client is the same). \nCalculations are based on total word count per recording order. ',
  },
  productHint10: {
    id: 'containers.SupplierProfile.components.Rates.productHint.10',
    defaultMessage: 'In-product voice-overs in gadgets, toys or machines. \n \nAlways pre-recorded voice-over instructing/guiding the user (battery status in headphones); or contributing to the product experience (talking teddy).',
  },
  productHint11: {
    id: 'containers.SupplierProfile.components.Rates.productHint.11',
    defaultMessage: 'A narrator voice guiding through the content, often in blocks. \n \nIt is often used for nature or historical documentaries. This voice-over can also be for TV content like reality, game or entertainment shows.',
  },
  productHint12: {
    id: 'containers.SupplierProfile.components.Rates.productHint.12',
    defaultMessage: 'A main commercial aired at a given platform. \nIt can be a tagline, promo, pre-roller or patronage. \n \nFree auditions are common practice in the voice decision process. \nMost often one original spot, often including edited cutdowns. ',
  },
  productHint37: {
    id: 'containers.SupplierProfile.components.Rates.productHint.37',
    defaultMessage: 'Narrator voices, as well as character roles. \nStamina is needed, as recorded content can be long, containing dialogue versions to support player interactiveness in the game.  \n',
  },
  productHint40: {
    id: 'containers.SupplierProfile.components.Rates.productHint.40',
    defaultMessage: 'Pre-recorded event narration for physical or online events. Mostly for business or company events.  ',
  },
  productHint46: {
    id: 'containers.SupplierProfile.components.Rates.productHint.46',
    defaultMessage: 'Telephone voice prompts for companies or organizations.',
  },
  productHint52: {
    id: 'containers.SupplierProfile.components.Rates.productHint.52',
    defaultMessage: 'Usually distributed via online streaming and download. Recordings often vary under 1 hour.',
  },
  productHint55: {
    id: 'containers.SupplierProfile.components.Rates.productHint.55',
    defaultMessage: 'A smaller character for commercials or elearning projects. For most character recordings like a grandpa, an uncle or the girlfriend, just a natural style is required.',
  },
  optionalProduct: {
    id: 'containers.SupplierProfile.components.Rates.optionalProduct',
    defaultMessage: 'Click to set rates (optional)',
  },
  requiredProduct: {
    id: 'containers.SupplierProfile.components.Rates.requiredProduct',
    defaultMessage: 'Required',
  },
  acceptedProduct: {
    id: 'containers.SupplierProfile.components.Rates.acceptedProduct',
    defaultMessage: 'Accepted',
  },
  acceptedProductCustom: {
    id: 'containers.SupplierProfile.components.Rates.acceptedProductCustom',
    defaultMessage: 'Filled in',
  },
  partiallyAcceptedProduct: {
    id: 'containers.SupplierProfile.components.Rates.partiallyAcceptedProduct',
    defaultMessage: 'Partially accepted',
  },
  acceptButtonLabel: {
    id: 'containers.SupplierProfile.components.Rates.acceptButton.label',
    defaultMessage: 'Accept and save my rates',
  },
  declineButtonLabel: {
    id: 'containers.SupplierProfile.components.Rates.declineButton.label',
    defaultMessage: 'I don\'t want perks',
  },
  declineButtonSubLabel: {
    id: 'containers.SupplierProfile.components.Rates.declineButton.label.sub',
    defaultMessage: 'Benefits and better exposure',
  },
  effectNotice: {
    id: 'containers.SupplierProfile.components.Rates.effectNotice',
    defaultMessage: '<bold>Notice!</bold> The prices is shown in EUR but you will be paid in the currency you have choosen under Bank and Payment details',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.Rates.validationFailed',
    defaultMessage: 'Rates step must be completed.',
  },
  currencySelectLabel: {
    id: 'containers.SupplierProfile.components.Rates.currencySelectLabel',
    defaultMessage: 'Supplier currency',
  },
  currencyUpdateSuccess: {
    id: 'containers.SupplierProfile.components.Rates.currencyUpdateSuccess',
    defaultMessage: 'Supplier currency updated successfully',
  },
})
